var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16671 6.41634H20.8334V3.66634H4.16671V6.41634ZM20.8334 8.24967V19.2497C20.8334 19.4928 20.7236 19.7259 20.5283 19.8979C20.3329 20.0698 20.068 20.1663 19.7917 20.1663H5.20837C4.93211 20.1663 4.66715 20.0698 4.4718 19.8979C4.27645 19.7259 4.16671 19.4928 4.16671 19.2497V8.24967H3.12504C2.84877 8.24967 2.58382 8.1531 2.38847 7.98119C2.19312 7.80928 2.08337 7.57612 2.08337 7.33301V2.74967C2.08337 2.50656 2.19312 2.2734 2.38847 2.10149C2.58382 1.92958 2.84877 1.83301 3.12504 1.83301H21.875C22.1513 1.83301 22.4163 1.92958 22.6116 2.10149C22.807 2.2734 22.9167 2.50656 22.9167 2.74967V7.33301C22.9167 7.57612 22.807 7.80928 22.6116 7.98119C22.4163 8.1531 22.1513 8.24967 21.875 8.24967H20.8334ZM6.25004 18.333H18.75V8.24967H6.25004V18.333ZM10.4167 14.6663H14.5834C14.8596 14.6663 15.1246 14.7629 15.3199 14.9348C15.5153 15.1067 15.625 15.3399 15.625 15.583C15.625 15.8261 15.5153 16.0593 15.3199 16.2312C15.1246 16.4031 14.8596 16.4997 14.5834 16.4997H10.4167C10.1404 16.4997 9.87549 16.4031 9.68014 16.2312C9.48479 16.0593 9.37504 15.8261 9.37504 15.583C9.37504 15.3399 9.48479 15.1067 9.68014 14.9348C9.87549 14.7629 10.1404 14.6663 10.4167 14.6663Z",
    fill: "#FF6A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveActive);
export default __webpack_public_path__ + "static/media/archive-active.0e3bc27c220822ea18e2255172d05eb7.svg";
export { ForwardRef as ReactComponent };